<section class="raci-template-view-section-area">
  <h1>{{'raciTemplate.title' | translate | uppercase}}</h1>
  <div style="display:flex">
    <raci-template-search-area *ngIf="searchActive" (search)="search($event)" style="width:15%">
    </raci-template-search-area>
    <kendo-grid id="kendoGridRaciTemplate" [kendoGridBinding]="gridView" kendoGridSelectBy="oid" [selectable]="selectableSettings"
                (selectionChange)="onSelect($event)" [pageSize]="15" [pageable]="true"
                [scrollable]="'scrollable'" [height]="500" style="width:100%">
      <kendo-grid-column [title]="'raciTemplate.status' | translate | uppercase" [width]="220">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span>{{ getStatus(dataItem.status) }}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="name" title="{{'raciTemplate.name' |  translate | uppercase}}" [width]="220">
      </kendo-grid-column>
      <kendo-grid-column field="oid" title="ID" [width]="220">
      </kendo-grid-column>
    </kendo-grid>
  </div>
</section>
